module.exports = {"name":"verifiedSkillsPilot","parameters":[{"name":"orgIds","value":[]}]}